import React, { useEffect, useRef, useState } from "react";
import classes from "./FiltersArea.module.scss";
import filterBar from "./../../../assets/images/filter_bar.svg";
import trigger from "./../../../assets/images/trigger.svg";
import calendar from "./../../../assets/images/calendar.svg";
import { useTranslation } from "react-i18next";

interface Interface {
  listUserFiltered?: any;
  listUser?: any;
  optionsGroups?: any;
  setListUserFiltered?: any;
}

const FiltersArea = ({
  // listUserFiltered,
  listUser,
  optionsGroups,
  setListUserFiltered,
}: Interface) => {
  const { t } = useTranslation();

  const [selectedOption, setSelectedOption] = useState("Tipo de usuário");
  const [selectedGroupsOption, setSelectedGroupsOption] = useState<any>(
    t("filters.users_groups")
  );
  const [groupsOptionHandler, setSelectedGroupsOptionHandler] = useState<any>(
    []
  );
  const [showOptions, setShowOptions] = useState(false);
  const [showGroupOptions, setShowGroupOptions] = useState(false);
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [startDateByDate, setStartDateByDate] = useState<string | null>(null);
  const [endDateByDate, setEndDateByDate] = useState<string | null>(null);
  const [callFuncTotalFat, setCallFuncTotalFat] = useState(false);

  const containerRef = useRef<HTMLDivElement>(null);
  const groupsRef = useRef<HTMLDivElement>(null);
  const datePickerRef = useRef<HTMLDivElement>(null);

  const options = [
    { value: t("filters.tipes_of_users"), label: t("filters.tipes_of_users") },
    { value: t("global.active"), label: t("global.active") },
    { value: t("global.blocked"), label: t("global.blocked") },
  ];

  useEffect(() => {
    let gHandler: any[] = [];
    if (optionsGroups && optionsGroups.length !== 0)
      gHandler = optionsGroups?.map((group: any) => ({
        value: group.name,
        label: group.name,
        status: group.status,
      }));
    gHandler = gHandler?.filter((group: any) => group.status === "active");
    gHandler?.unshift({ value: null, label: t("filters.user_without_group") });
    gHandler?.unshift({ value: 0, label: t("filters.users_groups") });
    setSelectedGroupsOptionHandler(gHandler);
  }, [optionsGroups, selectedGroupsOption]);

  const handleSelectChange = (item: any) => {
    const value = item;
    setSelectedOption(value);
    if (value === "Ativo") {
      setListUserFiltered(listUser.filter((user: any) => user.active === 1));
    } else if (value === "Bloqueado") {
      setListUserFiltered(listUser.filter((user: any) => user.active === 0));
    } else {
      setListUserFiltered(listUser);
    }
  };
  const handleSelectGroupChange = (value: any, label: any) => {
    setSelectedGroupsOption(label);
    if (value !== 0)
      setListUserFiltered(
        listUser.filter((user: any) => user.group_name === value)
      );
    else setListUserFiltered(listUser);
  };

  const onChangeStart = (event: React.ChangeEvent<HTMLInputElement>) => {
    const dateString = event.target.value;
    const formattedDate: string | null =
      dateString === "null" ? null : dateString;
    setStartDateByDate(formattedDate);
  };

  const onChangeEnd = (event: React.ChangeEvent<HTMLInputElement>) => {
    const dateString = event.target.value;
    const formattedDate: string | null =
      dateString === "null" ? null : dateString;
    setEndDateByDate(formattedDate);
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target as Node) &&
        !(
          datePickerRef.current &&
          datePickerRef.current.contains(event.target as Node)
        )
      ) {
        setShowOptions(false);
        setShowDatePicker(false);
        setStartDateByDate(null);
        setEndDateByDate(null);
      }
    };

    // Adicione o ouvinte de evento ao documento
    document.addEventListener("mousedown", handleClickOutside);

    // Limpe o ouvinte de evento quando o componente for desmontado
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [containerRef, showOptions, showDatePicker]);

  useEffect(() => {
    function filterItemsByDateRange(items: any, startDate: any, endDate: any) {
      // Converter as datas para o formato de data para facilitar a comparação
      const startDateObj = new Date(startDate);
      const endDateObj = new Date(endDate);

      // Definir manualmente os valores de hora, minuto, segundo e milissegundo para zero
      startDateObj.setHours(0, 0, 0, 0);
      endDateObj.setHours(0, 0, 0, 0);

      // Filtrar os itens que estão entre as datas especificadas
      return (
        items &&
        items.filter((item: any) => {
          const itemDate = new Date(item.date_created);

          // Definir manualmente os valores de hora, minuto, segundo e milissegundo para zero
          itemDate.setHours(0, 0, 0, 0);

          // Verificar se a data do item está dentro do intervalo especificado
          return itemDate >= startDateObj && itemDate <= endDateObj;
        })
      );
    }

    // Filtrar os itens pelo intervalo de datas
    const filteredOutputsAll = filterItemsByDateRange(
      listUser,
      startDateByDate,
      endDateByDate
    );
    startDateByDate && setListUserFiltered(filteredOutputsAll);
  }, [callFuncTotalFat]);

  return (
    <div className={classes.FiltersAreaMain}>
      <div className={classes.FiltersDescArea}>
        <img className={classes.FiltersImg} src={filterBar} alt="" />
        <div className={classes.FiltersDesc}>{t("filters.filter_by")}</div>
      </div>
      <div ref={containerRef}>
        <div
          onClick={() => setShowOptions(!showOptions)}
          className={classes.SelectArea}
        >
          {selectedOption}
          <img src={trigger} alt="" />
        </div>
        {showOptions && (
          <div className="search-list">
            <ul className={classes.TagInputOptions}>
              {options.map((item, index) => (
                <li
                  key={index}
                  onClick={() => {
                    handleSelectChange(item.label);
                    setShowOptions(false);
                  }}
                >
                  {item.label}
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
      <div ref={groupsRef}>
        <div
          onClick={() => setShowGroupOptions(!showGroupOptions)}
          className={classes.SelectArea}
          style={{ width: "auto", minWidth: "15em" }}
        >
          {selectedGroupsOption}
          <img src={trigger} alt="" />
        </div>
        {showGroupOptions && (
          <div className="search-list">
            <ul className={classes.TagInputOptions}>
              {groupsOptionHandler.map((item: any, index: any) => (
                <li
                  key={index}
                  onClick={() => {
                    handleSelectGroupChange(item.value, item.label);
                    setShowGroupOptions(false);
                  }}
                >
                  {item.label}
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
      <div>
        <div
          onClick={() => setShowDatePicker(!showDatePicker)}
          className={classes.DatePickerArea}
        >
          {startDateByDate && endDateByDate
            ? `${t("global.date")}: (${t(
                "global.of"
              )}: ${startDateByDate} - ${t("global.to")}: ${endDateByDate} )`
            : `${t("filters.invite_date")}`}
          <img src={calendar} alt="" />
        </div>
        {showDatePicker && (
          <div ref={datePickerRef} className={classes.DatePickerOptions}>
            <div className={classes.DaysFilter}>
              <div>{t("filters.filter_by_invite_date")}</div>
              <div className={classes.Filter}>
                <div>De:</div>
                <input onChange={onChangeStart} type="date" name="" id="" />
              </div>
              <div className={classes.Filter}>
                <div> Até:</div>
                <input onChange={onChangeEnd} type="date" name="" id="" />
              </div>
            </div>
            <div className={classes.ApplyFilterDatePickerArea}>
              <button
                onClick={() => {
                  setCallFuncTotalFat(!callFuncTotalFat);
                  setShowDatePicker(false);
                  // setIsNoContent(false);
                }}
                className={classes.ApplyFilterDatePicker}
              >
                Aplicar filtro
              </button>
            </div>
          </div>
        )}
      </div>

      <button
        onClick={() => {
          setListUserFiltered(listUser);
          setShowOptions(false);
          setShowDatePicker(false);
          setShowGroupOptions(false);
          setSelectedOption(t("filters.tipes_of_users"));
          setSelectedGroupsOption(t("filters.users_groups"));
        }}
        className={classes.CleanFilter}
      >
        ({t("filters.clear_filter")})
      </button>
    </div>
  );
};

export default FiltersArea;
